import React from 'react';
import Layout from 'shared/components/Layout';

export default function Route(props) {
	const { component, ...rest } = props;

	return <Layout {...rest}>{component}</Layout>;
}
